module.exports = "/_next/static/images/1269f97dccc7cfbe35313fd8f1b95884-phone-lg.png";